import { render, staticRenderFns } from "./SingleForm.vue?vue&type=template&id=fd0d9452"
import script from "./SingleForm.vue?vue&type=script&lang=js"
export * from "./SingleForm.vue?vue&type=script&lang=js"
import style0 from "./SingleForm.vue?vue&type=style&index=0&id=fd0d9452&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports